<template>
  <div class="UIPageLoader">
    <UISpinner size="md" />
  </div>
</template>

<script lang="ts" setup>
import { UISpinner } from '@foundever/ui-lib'
</script>

<style scoped lang="scss">
.UIPageLoader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
